import {Component, Inject, OnInit, Optional} from '@angular/core';
import {StoreSelectorsService} from '../../services';
import {Compbaser} from "../compbaser";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {take} from "rxjs/operators";
import {IAccountDetails} from "../../interfaces/enterprise-account-interface";
import {IUser} from "../../interfaces";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {actionUpdateCustomerEmail} from "../../store/actions/user.actions";

@Component({
    selector: 'app-dialog-email',
    templateUrl: './dialog-email.component.html',
    styleUrls: ['./dialog-email.component.scss'],
    standalone: false
})

export class DialogEmailComponent extends Compbaser implements OnInit {

    accountDetails: IAccountDetails;
    user: IUser;
    emailForm: FormGroup;

    constructor(@Optional() @Inject(MAT_DIALOG_DATA) data,
                private dialogRef: MatDialogRef<DialogEmailComponent>,
                private fb: FormBuilder,
                private storeSelector: StoreSelectorsService
    ) {
        super();
        this.emailForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
        dialogRef.afterClosed().subscribe(result => {
            this.onSubmit();
        });
    }

    ngOnInit(): void {
        this.cod(
            this.storeSelector.getUser().pipe(take(1))
                .subscribe((i_user: IUser) => {
                    this.user = i_user;
                })
        );
        this.cod(
            this.storeSelector.getUserAccountDetails()
                .pipe(take(1))
                .subscribe((i_accountDetails: IAccountDetails) => {
                    this.accountDetails = i_accountDetails;
                })
        );
    }

    onClose() {
        this.dialogRef.close();
    }

    onSubmit() {
        this.onClose();
        if (this.emailForm.valid) {
            this.storeSelector.dispatch(actionUpdateCustomerEmail({payload: this.emailForm.value.email}));
        }
    }
}

